import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-264ebb7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "overlayRef",
  class: "flow-preview-overlay"
}
const _hoisted_2 = { class: "preview-header" }
const _hoisted_3 = { class: "preview-header-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "preview-header-title" }, "Flow Ready for Review", -1))
const _hoisted_5 = { class: "preview-header-right" }
const _hoisted_6 = { class: "preview-flow-name" }
const _hoisted_7 = { class: "preview-step-count" }
const _hoisted_8 = { class: "preview-canvas" }
const _hoisted_9 = {
  key: 0,
  ref: "actionsRowRef",
  class: "preview-actions-row"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Request Changes", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1))
const _hoisted_15 = {
  key: 1,
  class: "preview-feedback"
}
const _hoisted_16 = { class: "preview-feedback-actions" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_FlowDiagram = _resolveComponent("FlowDiagram")!
  const _component_FlowPreviewCustomFields = _resolveComponent("FlowPreviewCustomFields")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          icon: "check-circle",
          class: "preview-header-icon"
        }),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.flowName), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.stepCount) + " step" + _toDisplayString(_ctx.stepCount !== 1 ? "s" : ""), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_FlowDiagram, {
        ref: "diagramRef",
        steps: _ctx.draftSteps,
        flow: _ctx.draftFlow,
        "flow-lines": _ctx.draftFlow.flowLines,
        "selected-step": null,
        "selected-index": -1,
        "list-index": '',
        "nodes-draggable": false,
        "start-step-position": -200,
        "background-color": '',
        "drawer-visible": false,
        "show-organize-steps": false,
        "show-input-summary": true,
        "enable-horizontal-trackpad-pan": true,
        class: "preview-flow-diagram"
      }, null, 8, ["steps", "flow", "flow-lines"]),
      _createVNode(_component_FlowPreviewCustomFields, {
        "flow-spec": _ctx.flowSpec,
        changes: _ctx.approvalChanges
      }, null, 8, ["flow-spec", "changes"])
    ]),
    (_ctx.showActions)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "preview-actions-panel",
          style: _normalizeStyle(_ctx.actionsPanelStyle)
        }, [
          (!_ctx.showFeedbackInput)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "preview-btn preview-btn--approve",
                  disabled: _ctx.submitting,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('approve')))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.submitting ? 'spinner' : 'check',
                    spin: _ctx.submitting
                  }, null, 8, ["icon", "spin"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.submitting ? _ctx.submittingLabel : _ctx.submitLabel), 1)
                ], 8, _hoisted_10),
                _createElementVNode("button", {
                  class: "preview-btn preview-btn--feedback",
                  disabled: _ctx.submitting,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFeedbackInput = true))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "comment" }),
                  _hoisted_12
                ], 8, _hoisted_11),
                _createElementVNode("button", {
                  class: "preview-btn preview-btn--reject",
                  disabled: _ctx.submitting,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reject')))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "times" }),
                  _hoisted_14
                ], 8, _hoisted_13)
              ], 512))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.feedbackText) = $event)),
                  class: "preview-feedback-input",
                  placeholder: "Describe what changes you'd like...",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, _ctx.feedbackText]
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "preview-btn preview-btn--send",
                    disabled: !_ctx.feedbackText.trim(),
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendFeedback && _ctx.sendFeedback(...args)))
                  }, " Send Feedback ", 8, _hoisted_17),
                  _createElementVNode("button", {
                    class: "preview-btn preview-btn--cancel-sm",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showFeedbackInput = false))
                  }, " Cancel ")
                ])
              ]))
        ], 4))
      : _createCommentVNode("", true)
  ], 512))
}